import { useState } from "react";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";
import { buildParams } from "../../../utils/admin-utils";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { formatDeclineNetSalesResponse } from "../../../utils/decline-net-sales-utils";

export function useDeclineNetSales() {
    const [declineNetSales, setDeclineNetSales] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchDeclineNetSales(pagination = {}) {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const params = buildParams(pagination);

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-queda-grupo?${params.toString()}`,
                requestOptions
                
            );

            if (!response.ok) {
                await throwResponseError(response, "Erro ao buscar penalidade por queda em Net Sales (Grupo)");
            }

            const data = await response.json();
            const declineNetSalesData = data.resultado || [];

            const responsePagination = {
                totalElements: data.totalElementos ?? 0,
                totalPages: data.totalPaginas ?? 0,
                page: data.pagina ?? 0,
                size: data.tamanho ?? pagination.size ?? 10
            };

            const formattedDeclineNetSales = Array.isArray(declineNetSalesData)
                ? declineNetSalesData.map(formatDeclineNetSalesResponse)
                : [];

            setDeclineNetSales(formattedDeclineNetSales);

            return {
                ok: true,
                empty: formattedDeclineNetSales.length === 0,
                declineNetSales: formattedDeclineNetSales,
                pagination: responsePagination
            };
        } catch (requestError) {
            setDeclineNetSales([]);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        declineNetSales,
        loading,
        error,
        refetch: fetchDeclineNetSales
    };
}